// themes.js — использует централизованные токены из styles/designTokens
import {
    backgroundPrimary,
    borderPrimary,
    textPrimaryShort,
    textMuted,
    textDisabled,
    backgroundSecondary,
    accentBlueBright,
    accentBlueLink,
    accentBlueButton,
    chartScrollbarGrip,
    designTokens,
} from "./styles/designTokens";

export const theme = {
    inputContainerBackground: backgroundPrimary,
    inputContainerBorder: borderPrimary,
    inputTextColor: textPrimaryShort,
    inputPlaceholderTextColor: textMuted,

    inputDisabledContainerBackground: backgroundPrimary,
    inputDisableTextColor: textDisabled,

    checkboxColor: accentBlueBright,
    checkMarkColor: textPrimaryShort,

    selectBackgroundColor: backgroundSecondary,
    selectTextColor: accentBlueBright,
    selectArrowColor: accentBlueBright,
    selectShadowColor: "rgba(0, 0, 0, 0.25)",
    selectScrollBarColor: chartScrollbarGrip,
    selectScrollThumbColor: "rgba(10, 10, 10, 0.2)",
    selectWrapperOptionBackgroundColor: chartScrollbarGrip,
    selectOptionBackgroundHovererColor: designTokens.background.tertiary,
    selectOptionTextColor: accentBlueBright,

    mainButtonBackgroundColor: accentBlueButton,
    mainButtonTextColor: textPrimaryShort,
    mainButtonDisabledBackgroundColor: textMuted,
    mainButtonDisabledTextColor: chartScrollbarGrip,

    cancelButtonBackgroundColor: chartScrollbarGrip,
    cancelButtonTextColor: accentBlueLink,
    cancelButtonDisabledBackgroundColor: textDisabled,

    blockButtonBackgroundColor: chartScrollbarGrip,
    blockButtonTextColor: accentBlueLink,
    blockButtonDisabledBackgroundColor: chartScrollbarGrip,

    transparentButtonTextColor: accentBlueLink,
};
